import src from "IMAGE";
export default { src, width: 975, height: 975, blurWidth: 0, blurHeight: 0};
